import { createFileRoute } from '@tanstack/react-router';
import { lerBusca, ListaPrecosPage } from '@/components/lista-precos';

export const Route = createFileRoute('/_app/precificar/lista')({
  validateSearch: (bruto: Record<string, unknown>) => lerBusca(bruto),
  component: ListaRota,
});

function ListaRota() {
  return <ListaPrecosPage busca={Route.useSearch()} />;
}
